module.exports = __webpack_public_path__ + "assets/media/day4.960d0283.mp3";